import settings from "@/core/settings"

export function searchOrCategoriesEnabled() {
  return settings.searchEnabled || settings.categoriesEnabled
}
